import PropTypes from "prop-types";

/**
 * PropTypes for TariffSidebar component.
 *
 * @property {Object|null} selectedTariff - Currently selected tariff object (null if no selection)
 * @property {Object} filters - Current filter state
 * @property {Function} onFilterChange - Filter change dispatcher
 * @property {number} visibleCount - Number of tariffs after filtering
 * @property {Array<Object>} tariffs - All tariffs data for building filter options
 * @property {Function} [onEditTariff] - Edit handler
 * @property {Function} [onToggleActive] - Activate/deactivate handler
 * @property {Function} [onDeleteTariff] - Delete handler
 * @property {boolean} [canEdit=false] - Whether actions are enabled
 */
export const tariffSidebarPropTypes = {
  selectedTariff: PropTypes.object,
  filters: PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  visibleCount: PropTypes.number.isRequired,
  tariffs: PropTypes.array.isRequired,
  onEditTariff: PropTypes.func,
  onToggleActive: PropTypes.func,
  onDeleteTariff: PropTypes.func,
  canEdit: PropTypes.bool,
};

/**
 * PropTypes for TariffFormModal component.
 *
 * @property {boolean} isOpen - Whether modal is visible
 * @property {Function} onClose - Callback to close modal
 * @property {Function} onSave - Callback to save tariff
 * @property {Object|null} [tariff] - Existing tariff to edit (null for create mode)
 * @property {Array<Object>} [chargePoints] - Available charge points for selection
 * @property {Function} [onRequestChargePointDetails] - Optional callback to load connectors for a charge point
 */
export const tariffFormModalPropTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  tariff: PropTypes.object,
  chargePoints: PropTypes.array,
  onRequestChargePointDetails: PropTypes.func,
};

/**
 * PropTypes for TariffDeleteModal component.
 *
 * @property {boolean} isOpen - Whether modal is visible
 * @property {Function} onClose - Callback to close modal
 * @property {Function} onConfirm - Callback to confirm deletion
 * @property {Object|null} [tariff] - Tariff to delete
 */
export const tariffDeleteModalPropTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  tariff: PropTypes.object,
};

/**
 * PropTypes for Tariffs view.
 * No external props are expected; kept for consistency across view definitions.
 */
export const tariffsViewPropTypes = {};
